import styled from 'styled-components';
import {FormIconWrapper} from '../form-control-features/FormIconWrapper';

export const FormLabel = styled.span`
    display: block;
    color: var(--label-text-color);
    font-size: var(--text-size-default);
    font-weight: 400;
    margin-bottom: var(--space-xsm);

    &:has(${FormIconWrapper.toString()}) {
        display: flex;
        justify-content: space-between;
    }
`;
